module.exports = __webpack_public_path__ + "static/media/sl_risk_score_trend_neutral.2a2c890d.svg";